"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.preview.title': 'Anteprima Test Bot',
    'botTest.preview.run': 'Esegui Test',
    'botTest.preview.edit': 'Modifica Test',
    'botTest.preview.back': 'Torna alla Lista',
    'botTest.preview.section.basic_info': 'Informazioni di Base',
    'botTest.preview.section.statistics': 'Statistiche',
    'botTest.preview.section.testers': 'Configurazione Test',
    'botTest.preview.not_provided': 'Non fornito',
    'botTest.preview.total_testers': 'Totale Tester',
    'botTest.preview.total_targets': 'Totale Obiettivi',
    'botTest.preview.creator': 'Creato da',
    'botTest.preview.unknown_creator': 'Sconosciuto',
    'botTest.preview.testers_count': 'Tester',
    'botTest.preview.targets_count': 'Obiettivi',
    'botTest.preview.created_date': 'Creato',
    'botTest.preview.updated_date': 'Ultimo aggiornamento',
    'botTest.preview.tester_configuration': 'Configurazione Tester',
    'botTest.preview.prompt_overridden': 'Prompt sovrascritto',
    'botTest.preview.no_targets': 'Nessun obiettivo configurato',
    'botTest.preview.unknown_avatar': 'Avatar sconosciuto',
    'botTest.preview.no_testers': 'Nessun Tester configurato',
    'botTest.preview.no_testers_description': 'Aggiungi tester per configurare i modelli IA e i prompt per i test.',
    'botTest.preview.not_found': 'Test Bot non trovato',
    'botTest.preview.not_found_description': 'Il test bot richiesto non è stato trovato o è stato eliminato.',
    'botTest.preview.no_model': 'Nessun modello',
    'botTest.preview.unknown_model': 'Modello sconosciuto',
    'botTest.preview.status.unknown': 'Sconosciuto',
    'botTest.preview.status.active': 'Attivo',
    'botTest.preview.status.inactive': 'Inattivo',
    'botTest.preview.status.standby': 'In Attesa',
    'botTest.preview.status.pending': 'In Attesa',
    'botTest.preview.status.running': 'In Esecuzione',
    'botTest.preview.status.completed': 'Completato',
    'botTest.preview.status.failed': 'Fallito',
    'botTest.preview.error.load_failed': 'Errore nel caricamento del test bot',
    'botTest.preview.run_confirmation': 'Sei sicuro di voler eseguire questo test?',
    'botTest.preview.run_started': 'Test bot avviato con successo',
    'botTest.preview.run_failed': 'Errore nell\'avvio del test bot',
    'botTest.preview.tabs.data': 'Dati',
    'botTest.preview.tabs.test_results': 'Risultati dei test',
    'botTest.preview.section.test_results': 'Risultati dei test',
    'botTest.preview.no_test_results': 'Nessun risultato del test disponibile',
    'botTest.preview.no_test_results_description': 'Eseguire il test bot per vedere i risultati qui.',
    'botTest.preview.model': 'Modello',
    'botTest.preview.temperature': 'Temperatura',
    'botTest.preview.completed': 'Completato',
    'botTest.preview.failed': 'Fallito',
    'botTest.preview.status': 'Stato',
    'botTest.preview.messages': 'Messaggi',
    'botTest.preview.tokens': 'Token',
    'botTest.preview.duration': 'Durata',
    'botTest.preview.total_messages': 'Messaggi totali',
    'botTest.preview.total_tokens': 'Token totali',
    'botTest.preview.avg_duration': 'Durata media',
};
